import { getAxiosBackendApi4 } from "../helpers/axios"

class ProjectsExhibitionServices{

    constructor(){
    }

    addProject(data){
        return getAxiosBackendApi4().post('projects', data)
    }

    getBooths(){
        return getAxiosBackendApi4().get('/projects/reserved-booths')
    }
}

export default new ProjectsExhibitionServices()